module.exports = __webpack_public_path__ + "img/symbol_1.70372553.png";